import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {useCookies} from "react-cookie";

import Analysis from "../sat-csp/Analysis";
import SelectCompetition from "../SelectCompetition";
import AnalysisCOP from "../cop/AnalysisCOP";
import Login from "../Login"

function App() {
    return (<BrowserRouter  basename="/XCSP22">
        <div>
            <Switch>
                <Route exact={true} path="/" component={SelectCompetition}/>
                <Route exact={true} path="/login"><Login /></Route>
                <Route exact={true} path={"/competitions/sat/:id"} component={Analysis} />
                <Route exact={true} path={"/competitions/csp/:id"} component={Analysis} />
                <Route exact={true} path={"/competitions/cop/:id"} component={AnalysisCOP} />
                <Route path="*" component={() => <p>Page Not Found</p>}/>
            </Switch>
        </div>
    </BrowserRouter>);
}

export default App;